import {ThrowPackingHistoricalData, ThrowPackingPrediction} from "../../../../autogenerate/api.generated.clients";
import {ChartSkeleton} from "../../../../components/Skeletons/ChartSkeleton";
import {AxisConfig, BarChart, ChartsXAxisProps} from "@mui/x-charts";
import {DashboardCard} from "../../../../components/DashboardCard/DashboardCard";
import {Card, Tooltip, Typography} from "@mui/material";
import {StatusIcon} from "../../../../components/StatusIcon/StatusIcon";

export interface ThrowPackingCardProps {
    data: ThrowPackingPrediction | undefined;
    isLoading: boolean;
}
function ThrowPackingCard(props: ThrowPackingCardProps) {
    const {data, isLoading} = props;
    if(!data || isLoading) {
        return  <div style={{width: "33%", height: '100%', alignSelf: 'center'}}>
                    <ChartSkeleton/>
                </div>;
    }
    
    const dataset= [
        {x: "No Packing Leak Detected", y: data.normalOperation, color: '#497b37'}, 
        {x: "Instrumentation Error", y: data.failedInstrumentation, color: '#707070'}, 
        {x: "Leak Detected", y: data.leakDetected, color: '#af3219'}, 
        {x: "ASC System\n Configuration Error", y: data.m_LinkConfigError, color: '#707070'}, 
        {x: "Inconclusive Operation", y: data.abnormalTemperature, color: '#f9ae33'}]
    
    function valueFormatter(value: number | null) {
        return `${value}%`;
    }
    return (
        <BarChart
            margin={{left: 140}}
            dataset={dataset}
            yAxis={[{scaleType: 'band', dataKey: 'x', colorMap: { type: 'ordinal', colors: dataset.map(d => d.color) }, tickLabelStyle: {fontSize: 10}}]}
            xAxis={[{ scaleType: 'linear',  min: 0, max: 100, domainLimit: 'strict', valueFormatter: valueFormatter}]}
            series={[{ dataKey: 'y', valueFormatter: valueFormatter}]}
            layout="horizontal"
            grid={{ vertical: true }}
        />
    );
}

export default ThrowPackingCard;